import api from "./api-configuration-v2";

/**
 * Kişi listesini getirir. Her zaman is_active === false olanlar gelir.
 * Ek filtreler opsiyonel olarak verilebilir: { tasiyici: true }, { kontrat: true } vs.
 */
export async function getTaseron(filter = {}) {
    try {
        const response = await api.post("subcontractor/getAll"); // API endpoint
        const allPersons = response.data.data;

        // is_active !== false olanları filtrele
        const nonDeleted = allPersons.filter(taseron => taseron.is_active === true);

        // Ek filtreleri uygula (örneğin tasiyici: true)
        const finalResult = nonDeleted.filter(taseron =>
            Object.entries(filter).every(([key, value]) => taseron[key] === value)
        );

        return finalResult;
    } catch (error) {
        console.error("Taşeron firmalar alınırken hata:", error);
        return [];
    }
}
